import {
  CapaErrorCode,
  CapaPurchaseOrderStatus,
  CapaQuotationChatRoomStatus,
  CapaQuotationPartnerStatus,
  CapaRfqQuotationType,
  CapaRfqReceivedType,
  FetchMyReceivedQuotationsQuery,
  FetchMyReceivedQuotationsQueryVariables
} from '@generated/graphql';
import { graphql } from 'msw';
import { v4 } from 'uuid';

const PURCHASE_ORDER_STATUS = Object.values(CapaPurchaseOrderStatus);

const generateQuotation = (
  rfqId: string,
  isTransaction: boolean,
  cost: number,
  introductionOnly: boolean,
  purchaseOrderStatus: CapaPurchaseOrderStatus = CapaPurchaseOrderStatus.PaymentFailed,
  partnerOrganizationName: string
) => {
  return {
    rfqId,
    rfqReceivedType: introductionOnly
      ? CapaRfqReceivedType.OnlyIntroduction
      : CapaRfqReceivedType.QuotationAndIntroduction,
    chatRoomCreatedAt: new Date().toISOString(),
    chatRoomId: v4(),
    chatRoomStatus: CapaQuotationChatRoomStatus.Opened,
    isTransaction,
    confirmCount: 45,
    cost,
    createdAt: new Date().toISOString(),
    deliveryCost: 5000,
    isAdjusted: false,
    organizationName: partnerOrganizationName,
    partnerId: v4(),
    profileId: null,
    quotationId: v4(),
    quotationPartnerStatus: CapaQuotationPartnerStatus.Approved,
    quotationType: CapaRfqQuotationType.Detail,
    read: false,
    purchaseOrderStatus: purchaseOrderStatus
  };
};

const fetchMyReceivedQuotations = graphql.query<
  FetchMyReceivedQuotationsQuery,
  FetchMyReceivedQuotationsQueryVariables
>('fetchMyReceivedQuotations', (req, res, ctx) => {
  const rfqId: string = req?.variables?.input?.rfqId ?? '';

  return res(
    ctx.data({
      fetchMyReceivedQuotations: {
        __typename: 'CAPAQuotationMyReceivedQuotationsOutput',
        result: CapaErrorCode.Success,
        errorMessage: null,
        data: PURCHASE_ORDER_STATUS.map((status, index, origin) => {
          return generateQuotation(
            rfqId,
            true,
            index * 1000000,
            index > origin.length,
            status,
            status
          );
        })
      }
    })
  );
});

export default fetchMyReceivedQuotations;
